import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchAppointmentDetail = async ({ appointmentId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${__API_URL__}/api/appointments/update_appointment/${appointmentId}/`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data.data;
};

const useGetAppointmentDetail = ({ appointmentId, enabled = true }) => {
  return useQuery({
    queryKey: ["appointment_detail", appointmentId],
    queryFn: () => fetchAppointmentDetail({ appointmentId }),
    enabled: enabled && Boolean(appointmentId),
  });
};

export default useGetAppointmentDetail;
